<template>
    <div class='menu'>
        <!-- logo -->
        <div class="home" :class='{active:dashFlag}' @click="activeTo(0)">
            <img v-show="dashFlag" src='~assets/image/icon-busys-white.png'>
            <img v-show="!dashFlag" src='~assets/image/icon-busys-green.png'>
        </div>

        <!-- 主菜单 -->
        <div class="main-choice" v-for="(data,index) in main_menu" :key="data.name">
            <div class='main-title' :class="{choice:!getSecondMenu(data).length,active:mainChoice(index)}"  @click="activeTo(index+1)">
                <div class="text">
                    <img class="icon" :src="data.icon | menuIcon(mainChoice(index))">
                    {{ data.text }}
                </div>
                <i v-show="getSecondMenu(data).length" class='el-icon-arrow-right' :class="{active:mainChoice(index) && menu_on}"></i>
                
            </div>
            <!-- 二级菜单 -->
            <div class="second-menu" :class="{active:mainChoice(index) && menu_on}">
                <div class="second-item choice" :class="{active:i == active_sec_index[index]}" v-for="(item,i) in getSecondMenu(data)" :key="item.name" @click.stop="linkTo(item.name)">
                    {{ item.text }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import frontRouter from "src/config/router-front-config.js"
    import { mapState,mapGetters } from "vuex"

    export default {
        data(){
            return {
                dashboard_route:frontRouter.children[0],
                activeTab:0,
                menu_on:true,   //允许下拉框出现
            }
        },
        computed:{
            ...mapState(['userInfo']),
            ...mapGetters(['codeList']),
            dashFlag(){
                return this.$route.name == 'dashboard';
            },
            main_menu(){  //主菜单
                return frontRouter.children.slice(2).filter(item=>{
                    item.meta = item.meta || {};

                    let codes = [  //不做BU限制
                        1100,   //个人财务
                        // 1200,   //文档管理
                        1500,   //审核管理
                    ]

                    let judge = [
                        item.meta.code == undefined && this.userInfo.bu.type == 0,   //自定义BU
                        this.codeList.some(code=> code == item.meta.code) && (this.userInfo.bu.type == 0 || codes.some(code=>code == item.meta.code) ), //有权限 且 有BU/在名单里
                    ]

					return judge.some(val=>val); 
				})
            },
            active_sec_index(){   //二级菜单激活数组
                return this.main_menu.map(item=>{
                    return 0;
                });
            }
        },
        watch:{
			"$route"(to,from){
				this.menuChange(to);
			}
		},
        created(){ 
			this.menuChange(this.$route);
		},
        methods:{

            mainChoice(index){
                return index == this.activeTab - 1;
            },

            getSecondMenu:(function(){  //构造二级菜单
                const map = new Map();
                return function(data){
                    let list = map.get(data);
                    if(list){
                        return list;
                    }

                    list = data.children || [];
                    list = list.filter(choice=>{
                        choice.meta = choice.meta || {};
                        let arr = [
                            choice.meta.code == undefined,
                            this.codeList.some(code=>code == choice.meta.code),
                        ]
                        return  choice.secondMenu == true && arr.some(val=>val);
                    });
                    map.set(data,list);
                    return list;
                }
            })(),

            linkTo(name){   //跳链
                this.$router.push({name:name});
            },

            activeTo(index){  //通过计算 跳链
                if(index == this.activeTab){
                    this.menu_on = !this.menu_on;
                    return;
                }
                this.menu_on = true;
                this.activeTab = index;
                if(index == 0){
                    this.linkTo('dashboard');
                    return;
                }

                let data = this.main_menu[index-1];
                let list = this.getSecondMenu(data);
                if(list.length){
                    this.menuChange(this.$route);
                    let secIndex = this.active_sec_index[index - 1];
                    let name = list[secIndex].name;
                    this.linkTo(name);
                    return;
                }

                this.linkTo(data.name);
            },
            menuChange(route){  //根据路由，安排菜单选项active状态
                let pathArr = route.fullPath.substring(1).split("/").map(str=>str.split('?')[0]);
                if(pathArr[0] == "dashboard"){
                    this.activeTab = 0;
                    return;
                }
                if(pathArr[0] == 'history-info'){
                    this.activeTab = -1;
                    return;
                }
				this.main_menu.some((one,index)=>{
					if(one.path == pathArr[0]){
						this.activeTab = index + 1;
						this.getSecondMenu(one).some((sec,i)=>{
							if(sec.path == pathArr[1]){
								this.active_sec_index[index] = i;
								return true;
							}
						});
						return true;
					}
				});
			}
        },
    }
</script>

<style lang="less" scoped>
    @import '~src/assets/less/var.less';
    .menu{
        width:@front_side_w;
        height:100%;
        float:left;
        color:#fff;
        background:#364760;
    }

    // 头部logo
    .home{
        height:60px;
        box-shadow: 0 1px 2px 0 #1d293b;
        box-sizing: border-box;
        position: relative;
        cursor: pointer;
        transition:0.3s;
        &.active{
            background:@main-c;
        }
        img{
            width: 130px;
            height:39px;
            position: absolute;
            left: 44%;
            top:50%;
            transform: translate(-50%,-50%);
        }
    }

    // 主菜单
    .main-title{
        height:56px;
        line-height: 56px;
        padding-left: 24px;
        cursor: pointer;
        font-size:14px;
        transition:0.3s;
        position: relative;
        &:hover{
            background:#48576a;
        }
        
        .text{
            .icon{
                height: 20px;
                width:20px;
                vertical-align: middle;
                margin-right:15px;
            }

        }

        i{
            transition:0.3s;
            position: absolute;
            top:50%;
            transform:translateY(-50%);
            right:20px;
            &.active{
                transform: translateY(-50%) rotate(90deg);
            }
        }
    }

    // 二级菜单
    .second-menu{
        position: relative;
        overflow: hidden;
        max-height:0;
        transition:0.5s;
        &.active{
            max-height:200px;
        }

        .second-item{
            background:#202e3d;
            padding-left: 60px;
            font-size:12px;
            height: 36px;
            line-height: 36px;
            cursor: pointer;
            transition:0.3s;
           

            &:hover{
                color:@main-c;
            }
        }
        
    }

    // 有active的可能性
    .choice{
        &.active{   //当前激活的菜单
            color:@main-c;
            box-shadow: 2px 0 0 0 @main-c inset;
            background:#48576a;
        }
    }
</style>


// WEBPACK FOOTER //
// frontMenu.vue?44524a97